export const environment = {
  production: false,
  domain: "https://rstsapi.optimly.in",
  //  domain: "http://localhost:3000",
  // domain: "https://exploreapi.optimly.in",
};
